<template>
  <div class="loading-skeleton">
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mb-3">
        <div class="skeleton-label"></div>
        <div class="skeleton-slots">
          <div class="skeleton-slot"></div>
          <div class="skeleton-slot"></div>
          <div class="skeleton-slot"></div>
          <div class="skeleton-slot"></div>
          <div class="skeleton-slot"></div>
          <div class="skeleton-slot"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentFormSkeleton'
};
</script>

<style scoped>
/* Loading Skeleton Styles */
.loading-skeleton {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.skeleton-label {
  height: 16px;
  width: 120px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-input {
  height: 38px;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
  border-radius: 4px;
}

.skeleton-slots {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-slot {
  height: 38px;
  width: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
  border-radius: 4px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .skeleton-label {
    width: 100px;
    height: 14px;
  }
  
  .skeleton-input {
    height: 36px;
  }
  
  .skeleton-slot {
    width: 70px;
    height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AppointmentFormSkeleton.vue